// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-icon-background-bg-color-gray: var(--ds-color-grey-indigo-50);
    --ds-icon-background-bg-color-red: var(--ds-color-negative);
    --ds-icon-background-bg-color-orange: var(--ds-color-alert);
    --ds-icon-background-bg-color-green: var(--ds-color-positive);
    --ds-icon-background-bg-color-indigo: var(--ds-color-indigo-2);
    --ds-icon-background-bg-color-pink: var(--ds-color-pink-3);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
